import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { styled } from "@mui/system";
import { CameraModalProps } from "../../../types/interfaces";
import { doc, setDoc } from "firebase/firestore";
import { db } from "@/Utils/firebase";
import { useAuth } from "@/context/auth.context";
import { useCustomNavigation } from "@/hooks/useCustomNavigation";
import { ScanUploader } from "@/services/ScanUploader";
import { logInfo } from "@/Utils/logger";
import { startNewJourney } from "@/telemetry/ids";

const StyledDialog = styled(Dialog)({
  "& .MuiPaper-root": {
    borderRadius: "20px",
    textAlign: "center",
    padding: "0px",
    width: "300px",
    backgroundColor: "#E3E6EB",
  },
});
const StyledDialogTitle = styled(DialogTitle)({
  fontWeight: "bold",
  fontSize: "18px",

  padding: "16px",
  backgroundColor: "#E3E6EB",
});
const StyledDialogContent = styled(DialogContent)({
  fontSize: "14px",
  padding: "0 24px 24px 24px",
  color: "#000",
  backgroundColor: "#E3E6EB",
});
const StyledDialogActions = styled(DialogActions)({
  display: "flex",
  justifyContent: "center",
  padding: "0",
  margin: "0",
  borderTop: "1px solid #ccc",
  backgroundColor: "#E3E6EB",
});
const ActionButton = styled(Button)({
  flex: 1,
  padding: "10px 0",
  margin: "0",
  border: "none",
  borderRadius: "0",
  fontWeight: "bold",
  color: "#007AFF",
  backgroundColor: "transparent",
  "&:hover": {
    backgroundColor: "rgba(0, 122, 255, 0.1)",
  },
  "&:first-of-type": {
    borderRight: "1px solid #ccc",
  },
  "&:not(:first-of-type)": {
    marginLeft: "0",
  },
});
const SubmissionDiscardModal: React.FC<CameraModalProps> = ({
  open,
  handleClose,
}) => {
  const { navigateTo } = useCustomNavigation();
  const { user } = useAuth();
  const discard = async () => {
    let scanID = localStorage.getItem("scanID");
    logInfo("[SubmissionDiscardModal] User pressed discard", {
      scanID,
      userId: user?.uid,
    });
    // The attempt ends here — the next scan is a new telemetry journey.
    startNewJourney();
    if (scanID) {
      const docRef = doc(db, `upload_processing/${scanID}`);

      await setDoc(
        docRef,
        {
          userId: user?.uid,
          discarded: true,
        },
        { merge: true },
      );
      ScanUploader.getInstance().discardScan();
      localStorage.removeItem("scanID");
      localStorage.removeItem("timestamp");
      navigateTo("/new-avatar-screen");
      handleClose();
    } else {
      navigateTo("/new-avatar-screen");
      handleClose();
    }
  };

  return (
    <StyledDialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <StyledDialogTitle id="alert-dialog-title">
        Avatar submission in progress
      </StyledDialogTitle>
      <StyledDialogContent>
        <DialogContentText id="alert-dialog-description">
          Your last submission is still in-progress. You can wait for the
          submission to finish or discard it to create a new avatar now.
        </DialogContentText>
      </StyledDialogContent>
      <StyledDialogActions>
        <ActionButton
          onClick={() => {
            discard();
          }}
        >
          Discard
        </ActionButton>
        <ActionButton onClick={handleClose}>Wait</ActionButton>
      </StyledDialogActions>
    </StyledDialog>
  );
};
export default SubmissionDiscardModal;
